import * as yup from 'yup';

export const indexedObject = schema => {
  return yup.lazy(obj =>
    obj
      ? yup.object(
          Object.keys(obj).reduce(
            (r, v) =>
              Object.assign(r, {
                [v]: schema,
              }),
            {}
          )
        )
      : yup.mixed()
  );
};

export default indexedObject;
